/* eslint-disable react/destructuring-assignment */
import React from 'react'
import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap'
import { connect } from 'react-redux'
import { userActions } from '../../../redux/actions'
import { currentUser } from '../../../redux/reducers/user.reducers'
import FormattedMessage from '../../../components/FormattedMessage/FormattedMessage'
import ChangePasswordForm from '../../../components/Form/ChangePasswordForm/ChangePasswordForm'
import './ChangePassword.scss'

class ChangePassword extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      modal: false,
      successModal: false,
    }
  }

  onSubmit = payload => {
    if (!this.props.user || !this.props.user.email) {
      console.error('User email not available')
      return Promise.reject(new Error('User email not available'))
    }
    return this.props
      .changePassword({ ...payload, email: this.props.user.email })
      .then(() => {
        this.setState({ modal: false, successModal: true })
      })
      .catch(error => {
        throw error
      })
  }

  toggleModal = () => {
    this.setState(prev => ({
      modal: !prev.modal,
    }))
  }

  toggleSuccessModal = () => {
    this.setState(prev => ({
      successModal: !prev.successModal,
    }))
  }

  render() {
    if (!this.props.user) {
      return null
    }

    return (
      <div>
        <div className="row justify-content-center py-4">
          <div className="col-md-8 col-xl-6">
            <Button
              name="changePwSubmitBtn"
              type="button"
              outline
              color="dark"
              size="sm"
              onClick={this.toggleModal}
              block
              aria-label="Change Password"
            >
              <FormattedMessage id="global.label.changePassword" />
            </Button>
          </div>
        </div>

        <Modal
          isOpen={this.state.modal}
          toggle={this.toggleModal}
          className="change-password-modal"
          size="lg"
          aria-label="Change Password"
        >
          <ModalHeader toggle={this.toggleModal}>
            <span className="sr-only">
              <FormattedMessage id="global.label.close" defaultMessage="Close" />
            </span>
          </ModalHeader>
          <ModalBody>
            <ChangePasswordForm onSubmit={this.onSubmit} userEmail={this.props.user?.email} />
          </ModalBody>
        </Modal>

        <Modal
          isOpen={this.state.successModal}
          toggle={this.toggleSuccessModal}
          className="change-password-success-modal"
          size="lg"
          aria-labelledby="change-password-success-modal-title"
        >
          <ModalHeader toggle={this.toggleSuccessModal}>
            <span className="sr-only">
              <FormattedMessage id="global.label.close" defaultMessage="Close" />
            </span>
          </ModalHeader>
          <ModalBody>
            <h2 id="change-password-success-modal-title" className="text-center">
              <FormattedMessage id="success.passwordChange.completeTitle" />
            </h2>
          </ModalBody>
          <ModalFooter>
            <div className="w-100">
              <div className="row">
                <div className="col">
                  <Button
                    block
                    outline
                    color="light"
                    onClick={this.toggleSuccessModal}
                    aria-label="Close this message"
                  >
                    OK
                  </Button>
                </div>
              </div>
            </div>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  user: currentUser(state),
})

const mapDispatchToProps = dispatch => ({
  changePassword: (...args) => dispatch(userActions.changePassword(...args)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword)
